import React, { useState } from 'react';
import {
    FaClipboardCheck, FaChartBar, FaCalendarAlt, FaPlus,
    FaFileExcel, FaFilePdf, FaDownload
} from 'react-icons/fa';
import EventosView from './EventosView';
import ChecklistView from './ChecklistView';
import EventosDashboard from './EventosDashboard';
import EventosCalendario from './EventosCalendario';
import axiosInstance from '../utils/axiosConfig';
import './EventosMainView.css';

const TABS = [
    { id: 'operaciones', label: 'Operaciones', icon: FaClipboardCheck },
    { id: 'estadisticas', label: 'Estadísticas', icon: FaChartBar },
    { id: 'calendario', label: 'Calendario', icon: FaCalendarAlt },
];

const EventosMainView = () => {
    const [activeTab, setActiveTab] = useState('operaciones');
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [exportMenuOpen, setExportMenuOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleExport = async (format) => {
        setExportMenuOpen(false);
        try {
            const response = await axiosInstance.get(`/api/eventos/exportar/${format}`, {
                params: { dias: 30 },
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.download = `bitacora_eventos.${format === 'excel' ? 'xlsx' : 'pdf'}`;
            link.click();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Error exportando:', err);
        }
    };

    return (
        <div className="eventos-main-view">
            {/* Command Bar */}
            <div className="ops-command-bar">
                <h1>Eventos</h1>

                <div className="ops-tabs">
                    {TABS.map(tab => (
                        <button
                            key={tab.id}
                            className={`ops-tab ${activeTab === tab.id ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            <tab.icon size={12} />
                            {tab.label}
                        </button>
                    ))}
                </div>

                {activeTab === 'operaciones' && (
                    <div className="ops-actions">
                        <div className="relative">
                            <button
                                onClick={() => setExportMenuOpen(!exportMenuOpen)}
                                className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-gray-500 bg-white border border-gray-200 rounded-lg hover:border-gray-300 hover:text-gray-700 transition-colors"
                            >
                                <FaDownload size={10} />
                                Exportar
                            </button>
                            {exportMenuOpen && (
                                <>
                                    <div className="fixed inset-0 z-10" onClick={() => setExportMenuOpen(false)} />
                                    <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-20 overflow-hidden min-w-[140px]">
                                        <button
                                            onClick={() => handleExport('excel')}
                                            className="w-full flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                                        >
                                            <FaFileExcel size={12} className="text-green-600" />
                                            Excel
                                        </button>
                                        <button
                                            onClick={() => handleExport('pdf')}
                                            className="w-full flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                                        >
                                            <FaFilePdf size={12} className="text-red-600" />
                                            PDF
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                        <button
                            onClick={() => setShowCreateModal(true)}
                            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-white bg-sura-blue rounded-lg hover:bg-sura-blue-dark transition-colors"
                        >
                            <FaPlus size={10} />
                            Nuevo Evento
                        </button>
                    </div>
                )}
            </div>

            {/* Tab: Operaciones */}
            {activeTab === 'operaciones' && (
                <div className="ops-layout">
                    <div className="ops-panel">
                        <div className="ops-panel-header">
                            <h2 className="ops-panel-title">Checklist Diario</h2>
                        </div>
                        <div className="ops-panel-body">
                            <ChecklistView />
                        </div>
                    </div>
                    <div className="ops-panel">
                        <EventosView
                            showCreateModal={showCreateModal}
                            onCloseCreateModal={() => setShowCreateModal(false)}
                            onEventCreated={() => setRefreshKey(k => k + 1)}
                            key={refreshKey}
                        />
                    </div>
                </div>
            )}

            {/* Tab: Estadísticas */}
            {activeTab === 'estadisticas' && (
                <div className="ops-tab-content">
                    <EventosDashboard />
                </div>
            )}

            {/* Tab: Calendario */}
            {activeTab === 'calendario' && (
                <div className="ops-tab-content">
                    <EventosCalendario />
                </div>
            )}
        </div>
    );
};

export default EventosMainView;
